import styled, { css } from 'styled-components';

export const media = {
  handheld: (...args) => css`
    @media (max-width: 1024px) {
      ${css(...args)};
    }
  `,
};

export const redOrGreen = value => {
  return {
    color: value > 0 ? '#1bc700' : '#c70032',
  };
};

export const Button = styled.button`
  margin: 20px 0 0 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  font-family: Arial;
  color: #ffffff;
  font-size: 18px;
  border-radius: 3px;
  background: #4cb4a4;
  border: 1px solid #4cb4a4;
  padding: 8px 20px 8px 20px;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background: #fff;
    text-decoration: none;
    color: #4cb4a4;
  }
`;

export const FreeTextSearchInput = styled.input`
  border: 1px solid #fff;
  border-radius: 3px
  margin: 0 20px 0 0;
  padding: 8px 10px;
  width: 220px;
  font-size: 16px;
  ${media.handheld`
    margin 0 0 10px 0;
`};
`;

export const MobileLabel = styled.span`
  display: none;
  ${media.handheld`
    flex-direction: column;
    align-items: left;
    `};
`;

export const CryptoListContainer = styled.div`
  font-family: 'verdana';
  font-size: 14px;
  margin: 40px auto;
  max-width: 1000px;
  padding: 0;
  color: #525a58;
`;

export const List = styled.ul`
  margin: 10px 0 0 0;
  padding: 0 !important;

  ${media.handheld`
        display:flex;
        flex-wrap: wrap;
    `};
`;

export const ListItem = styled.li`
  background-color: #fff;
  padding: 8px 5px;
  margin: 5px 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${media.handheld`
    flex-direction: row;
    max-width: 360px;
    margin: 5px auto;
    background: none;
    padding: 0;
  `};
`;

export const ListHeader = styled.li`
  background-color: #4cb4a4;
  color: #fff;
  font-weight: bold;
  padding: 5px;
  margin: 5px 0;
  list-style-type: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  ${media.handheld`
    display:none;
  `};
`;

export const ListItemValue = styled.span`
  margin: 0 5px;
  width: 200px;
  align-items: center;
  display: flex;
  ${media.handheld`

  `};
`;

export const ListItemHeaderValue = styled.span`
  cursor: pointer;
  margin: 0 5px;
  width: 200px;
  align-items: center;
  display: flex;
  ${media.handheld`

  `};
`;

export const ListItemHeader = styled.span`
  margin: 0 5px;
  width: 160px;
`;

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #4cb4a4;
  padding: 20px;
  ${media.handheld`
    flex-direction: column;
  `};
`;
